import React from 'react';
import Slider from 'react-slick';
import { Container } from 'react-bootstrap'
import {NextArrowCarusel,  PrevArrowCarusel} from '~/shared/ArrowsCarousel'
import { TimelineCardMobile } from './TimelineCard';
import { CardContent } from './styles'


const TimelineMobile = () => {

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        autoplay: false,
        autoplaySpeed: 2000,
        centerPadding: "60px",
        nextArrow: <NextArrowCarusel />,
        prevArrow: <PrevArrowCarusel />,

      }

  return (
          <CardContent>
            <Slider {...settings}>
            <TimelineCardMobile  image="/images/picture.png" alt="icone de imagem">
                <p>
                    <strong>67%</strong> dos consumidores consideram que as <strong>fotos</strong> profissionais <strong>são importantes</strong> para <strong>motivá-los a realizar a compra.</strong>
                </p>
            </TimelineCardMobile>

            <TimelineCardMobile  image="/images/galery.png" alt="icone de galeria">
                <p>
                     <strong>63%</strong> dos consumidores consideram as <strong>imagens mais importantes do que as informações</strong> de um anúncio.
                </p>
            </TimelineCardMobile>

            <TimelineCardMobile  image="/images/dolar_white.png" alt="icone de moeda">
                <p>
                    O comportamento mudou: com o <strong>tour virtual</strong> os <strong>compradores potenciais visitam</strong> vários imóveis do conforto de suas casas em uma fração do tempo, <strong>sem mais gastos com deslocamentos</strong> e tempo.
                </p>
            </TimelineCardMobile>

            <TimelineCardMobile  image="/images/movie.png" alt="icone de filmadora">
                <p>
                    Os <strong>anúncios com vídeos</strong> recebem <strong>30%</strong> a mais de ofertas
                </p>
            </TimelineCardMobile>

            <TimelineCardMobile  image="/images/user.png" alt="icone de usuario">
                <p>
                    Artigos com boas imagens têm <strong>94% mais visualizações</strong> comparados aos que não usam esse recurso.
                </p>
            </TimelineCardMobile>

            <TimelineCardMobile  image="/images/pc_white.png" alt="icone de computador">
                <p>
                    Com o <strong>tour virtual</strong> o cliente pode conhecer o ambiente mesmo a distância e essa tecnologia <strong> é capaz de gerar o dobro de interesse</strong> dos seus consumidores, além de ser um diferencial na experiência do cliente.
                </p>
            </TimelineCardMobile>
            </Slider>
          </CardContent>
  )
}

export default TimelineMobile;
